export const PRODUCTS = [
    {
        id: 'marginlayer',
        name: 'MarginLayer',
        tagline: 'Коммерческий слой между трекером и финансами',
        description:
            'Платформа для IT-аутсорса и консалтинга: связывает согласованный объём работ, фактические часы, изменения scope и готовность к счёту. Риски по марже видны в еженедельном ритме — не только в конце месяца.',
        features: [
            'Базовая линия scope и burn по проектам',
            'Импорт часов из Jira или CSV',
            'Контроль scope change с денежным статусом',
            'Еженедельный снимок готовности к счёту',
        ],
        audience: 'Команды 10–50 человек, T&M и гибридные контракты',
        url: 'https://marginlayer.app/ru',
        cta: 'Узнать о MarginLayer',
        accent: 'marginlayer',
    },
    {
        id: 'devopsfort',
        name: 'DevOpsFort',
        tagline: 'Безопасные контейнеры для вашего облака',
        description:
            'Сервис hardened OCI-образов с минимальной поверхностью CVE. Регулярная пересборка, контроль уязвимостей до публикации в приватный реестр. Встраивается в GitLab CI, Kubernetes и Docker Compose.',
        features: [
            'Образы nginx, PostgreSQL, Redis, Python и др.',
            'CVE gate до публикации в реестр',
            'Интеграция в существующие пайплайны',
            'Зеркалирование для изолированных контуров',
        ],
        audience: 'DevOps, платформенная инженерия и ИБ',
        url: 'https://devopsfort.ru/',
        cta: 'Узнать о DevOpsFort',
        accent: 'devopsfort',
    },
    {
        id: 'bc',
        name: 'bc',
        tagline: 'Кодинг-ассистент с квотами под команду',
        description:
            'Облачный coding assistant на Qwen2.5-Coder: Ask, Agent и VS Code для вашей команды. Тарифы Starter / Pro / Ultra с дневными и месячными лимитами, admin для организаций и API keys, trial 7–14 дней на Starter.',
        features: [
            'Web UI, VS Code extension и OpenAI-compatible API',
            'Тарифы от 1 990 ₽ / мес · trial на Starter',
            'Квоты soft/hard и usage по организации и ключам',
            'Готовый сервис Betuple — без своей инфра под LLM',
        ],
        audience: 'Инженерные команды, платформа и продуктовая разработка',
        url: 'https://bc.apps.betuple.com/landing',
        cta: 'Тарифы и landing bc',
        accent: 'bc',
    },
];

export const PILOTS = [
    {
        id: 'marginlayer',
        product: 'MarginLayer',
        productId: 'marginlayer',
        title: 'Пилот для IT-аутсорса и консалтинга',
        text:
            'Подключаем платформу к вашим проектам: baseline scope, импорт часов из Jira или CSV, еженедельный снимок готовности к счёту и контроль рисков по марже.',
        accent: 'marginlayer',
    },
    {
        id: 'devopsfort',
        product: 'DevOpsFort',
        productId: 'devopsfort',
        title: 'Пилот hardened OCI-образов',
        text:
            'Согласуем набор образов, подключаем приватный реестр к pipeline и проходим CVE gate в GitLab CI / Kubernetes на вашем контуре.',
        accent: 'devopsfort',
    },
    {
        id: 'bc',
        product: 'bc',
        productId: 'bc',
        title: 'Trial кодинг-ассистента',
        text:
            'Выдаём API key на Starter на 7–14 дней: чат, Agent и VS Code. Смотрите тарифы на landing и пишите заявку — подключим к вашему сценарию.',
        accent: 'bc',
    },
];

export const LEAD_PRODUCTS = [
    { value: 'marginlayer', label: 'MarginLayer' },
    { value: 'devopsfort', label: 'DevOpsFort' },
    { value: 'bc', label: 'bc — coding assistant' },
    { value: 'devops', label: 'DevOps-услуги' },
    { value: 'betuple', label: 'Не уверен / несколько продуктов' },
];

export const COMPANY = {
    name: 'ООО «Битапл»',
    address: '115280, город Москва, ул. Ленинская Слобода, д. 17',
    email: 'contact@betuple.com',
    inn: '9725072930',
    ogrn: '1227700043427',
};

export const NAV = [
    { id: 'products', label: 'Продукты' },
    { id: 'pilots', label: 'Пилоты' },
    { id: 'about', label: 'О компании' },
    { id: 'contact', label: 'Контакты' },
];
